import { map } from 'lodash-es';

const transformLoadHolidays = (holidays: any[]) => map(holidays, holiday => new Date(holiday.date));

export default transformLoadHolidays;
